import React from 'react';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';
import Link from '@mui/material/Link';
import CardItem from 'components/CardItem';
import Card from 'components/Card';

export default function CardManufacturers(props) {
  const navigate = useNavigate();

  function manufacturersModels() {
    navigate(`/veiculos/${props.manufacturers.id}/modelos`);
  }

  return (
    <Grid container direction="column" alignItems="flex-start">
      <Grid item xs={12} style={{ width: '100%', maxWidth: '720px' }}>
        <Card
          bordered
          style={{
            marginTop: '10px',
            borderLeft: '4px solid #d9dde3',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 16px',
            }}
          >
            <CardItem className="nameClients" style={{ margin: 0 }}>
              {props.manufacturers.name}
            </CardItem>
            <Link
              style={{
                fontWeight: 'bold',
                textTransform: 'uppercase',
                cursor: 'pointer',
              }}
              onClick={() => manufacturersModels()}
            >
              Ver modelos <i className="fas fa-chevron-right" />
            </Link>
          </div>
        </Card>
      </Grid>
    </Grid>
  );
}
